import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import { fontBrand } from '../../../../getLPTheme';

export default function SlackUser () {
    return (
      <Box>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pt: { xs: 5, sm: 5 },
          }}
        >
          <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%' } }}>
            <Typography 
              fontFamily={fontBrand.principal}
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignSelf: 'center',
                textAlign: 'center',
                fontSize: '5vw'
              }}
            >
              Seleccionaste Slack 
            </Typography>
            <Typography variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{fontSize: '2vw'}}>
                Link
            </Typography>
            {/* <Card sx={{hight:300, width: '100%'}}>
              <Box sx={{ position: 'relative' }}>
                <CardMedia component='img' image={"images/notebook.png"}></CardMedia>
              </Box>
            </Card> */}
          </Stack>
        </Container>
      </Box>
    );
  }